import React from 'react';
import SectionIntro from './SectionIntro';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const outcomes = [
  { title: 'Increase Profitability', desc: 'See where money is made — and where it leaks — in real time.' },
  { title: 'Reduce Operational Costs', desc: 'Cut waste, overtime, and redundant tooling with unified systems.' },
  { title: 'Prevent Inventory Loss', desc: 'Track every unit from delivery to sale with live visibility.' },
  { title: 'Automate Repetitive Work', desc: 'Free your team from manual entry, reconciliation, and chasing data.' },
  { title: 'Improve Customer Experience', desc: 'Faster service, smarter loyalty, and consistent quality.' },
  { title: 'Real-Time Business Insights', desc: 'Decisions based on live operations — not last month’s reports.' },
  { title: 'Scale Across Multiple Branches', desc: 'One operating standard across every location you grow into.' },
  { title: 'AI-Powered Decision Making', desc: 'Forecast demand, optimize stock, and act before problems hit.' },
];

const WhyNexasolutra: React.FC = () => {
  const { ref, isVisible } = useScrollAnimation(0.05);

  return (
    <section className="section-pad relative">
      <div className="max-w-7xl mx-auto">
        <SectionIntro
          label="Why Nexasolutra"
          title="Built for business outcomes — not feature lists."
          body="We measure success by profitability, efficiency, and the clarity of your operation."
          aside="Eight outcomes we hold ourselves to on every deployment."
          className="mb-14 md:mb-20"
        />

        {/* An editorial ledger: full-bleed rows that light up one at a time on hover. */}
        <div ref={ref} className={isVisible ? 'is-visible' : ''}>
          {outcomes.map((item, i) => (
            <article key={item.title} className="outcome group" tabIndex={0}>
              <div className="outcome__row">
                <span className="outcome__index font-display text-2xl lg:text-4xl font-extrabold">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <h3 className="font-display text-xl lg:text-3xl font-bold text-white tracking-tight text-balance">
                  {item.title}
                </h3>
                <div className="col-start-2 lg:col-start-3 flex items-baseline justify-between gap-6">
                  <p className="outcome__desc text-sm lg:text-base leading-relaxed max-w-xl">
                    {item.desc}
                  </p>
                  <span className="outcome__arrow text-2xl font-display shrink-0" aria-hidden>
                    →
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyNexasolutra;
